import type { Observable as ObservableType } from 'rxjs/Observable';
import { fetchJson$ } from '@atlassian/jira-fetch';
import type { Issue } from '../../model/issue/types';

export function fetchIssue(boardId: string, issueId: number): ObservableType<Issue> {
	return fetchJson$(
		`/rest/greenhopper/1.0/xboard/plan/backlog/issue.json?rapidViewId=${boardId}&issueId=${issueId}`,
	);
}
